import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
/**
 * @file
 * Portal 提供一种将子节点渲染到存在于父组件以外的 DOM 节点的机制.
 */
import { noop } from '@seiue/util';
import React from 'react';
const PORTAL_PREFIX = 'portal_';
let portalNextKey = 0;
export const Portal = {
    add: noop,
    remove: noop,
    Host: () => null,
};
const PortalHost = () => {
    const [portals, setPortals] = React.useState([]);
    Portal.add = (element) => {
        portalNextKey += 1;
        const key = `${PORTAL_PREFIX}${portalNextKey}`;
        setPortals([
            ...portals,
            {
                key,
                children: element,
            },
        ]);
        return key;
    };
    Portal.remove = (portalKey) => {
        setPortals(prevPortals => prevPortals.filter(portal => portal.key !== portalKey));
    };
    return (_jsx(_Fragment, { children: portals.map(portal => (_jsx(React.Fragment, { children: portal.children }, portal.key))) }, void 0));
};
Portal.Host = PortalHost;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvUG9ydGFsL2luZGV4LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUE7OztHQUdHO0FBRUgsT0FBTyxFQUFFLElBQUksRUFBRSxNQUFNLGFBQWEsQ0FBQTtBQUNsQyxPQUFPLEtBQUssTUFBTSxPQUFPLENBQUE7QUFFekIsTUFBTSxhQUFhLEdBQUcsU0FBUyxDQUFBO0FBRS9CLElBQUksYUFBYSxHQUFHLENBQUMsQ0FBQTtBQUVyQixNQUFNLENBQUMsTUFBTSxNQUFNLEdBSWY7SUFDRixHQUFHLEVBQUUsSUFBVztJQUNoQixNQUFNLEVBQUUsSUFBVztJQUNuQixJQUFJLEVBQUUsR0FBRyxFQUFFLENBQUMsSUFBSTtDQUNqQixDQUFBO0FBRUQsTUFBTSxVQUFVLEdBQWEsR0FBRyxFQUFFO0lBQ2hDLE1BQU0sQ0FBQyxPQUFPLEVBQUUsVUFBVSxDQUFDLEdBQUcsS0FBSyxDQUFDLFFBQVEsQ0FLMUMsRUFBRSxDQUFDLENBQUE7SUFFTCxNQUFNLENBQUMsR0FBRyxHQUFHLENBQUMsT0FBMkIsRUFBRSxFQUFFO1FBQzNDLGFBQWEsSUFBSSxDQUFDLENBQUE7UUFFbEIsTUFBTSxHQUFHLEdBQUcsR0FBRyxhQUFhLEdBQUcsYUFBYSxFQUFFLENBQUE7UUFFOUMsVUFBVSxDQUFDO1lBQ1QsR0FBRyxPQUFPO1lBQ1Y7Z0JBQ0UsR0FBRztnQkFDSCxRQUFRLEVBQUUsT0FBTzthQUNsQjtTQUNGLENBQUMsQ0FBQTtRQUVGLE9BQU8sR0FBRyxDQUFBO0lBQ1osQ0FBQyxDQUFBO0lBRUQsTUFBTSxDQUFDLE1BQU0sR0FBRyxDQUFDLFNBQWlCLEVBQUUsRUFBRTtRQUNwQyxVQUFVLENBQUMsV0FBVyxDQUFDLEVBQUUsQ0FDdkIsV0FBVyxDQUFDLE1BQU0sQ0FBQyxNQUFNLENBQUMsRUFBRSxDQUFDLE1BQU0sQ0FBQyxHQUFHLEtBQUssU0FBUyxDQUFDLENBQ3ZELENBQUE7SUFDSCxDQUFDLENBQUE7SUFFRCxPQUFPLENBQ0wsNEJBQ0csT0FBTyxDQUFDLEdBQUcsQ0FBQyxNQUFNLENBQUMsRUFBRSxDQUFDLENBQ3JCLEtBQUMsS0FBSyxDQUFDLFFBQVEsY0FBbUIsTUFBTSxDQUFDLFFBQVEsSUFBNUIsTUFBTSxDQUFDLEdBQUcsQ0FBb0MsQ0FDcEUsQ0FBQyxXQUNELENBQ0osQ0FBQTtBQUNILENBQUMsQ0FBQTtBQUVELE1BQU0sQ0FBQyxJQUFJLEdBQUcsVUFBVSxDQUFBIn0=